// extracted by mini-css-extract-plugin
export default {"root":"style_root__3N-kz","content":"style_content__jB0XW"};